import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Choix } from 'src/app/utils/interfaces/new/Choix';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Liste } from 'src/app/utils/interfaces/new/Liste';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ListeChoixService {

  private isMock = environment.mock;
  private _wait = (ms) => new Promise(res => setTimeout(res, ms));
  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };
  private uriListe = environment.basePath + "/personnalisation/listes";
  private uriChoix = environment.basePath + "/personnalisation/choix";

  constructor(
    private http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async createListe(liste: Liste): Promise<string> {
    try {
      const res = await this.http.post(this.uriListe, liste, this.httpOptions).toPromise();
      const id = res.body as string;
      return id;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findListes(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
  }): Promise<Paginated<Liste>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(this.uriListe, this.httpOptions).toPromise();
      const listes = res.body as Liste[];
      const paginated: Paginated<Liste> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: listes
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async deleteListe(listeId: string) {
    try {
      const res = await this.http.delete(this.uriListe + "/" + listeId, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async createChoix(choix: Choix): Promise<string> {
    try {
      const res = await this.http.post(this.uriChoix, choix, this.httpOptions).toPromise();
      const id = res.body as string;
      return id;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findByListeId(listeId: string, filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
  }): Promise<Paginated<Choix>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(this.uriChoix + "/liste/" + listeId, this.httpOptions).toPromise();
      const choix = res.body as Choix[];
      const paginated: Paginated<Choix> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: choix
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async deleteChoix(choixId: string) {
    try {
      const res = await this.http.delete(this.uriChoix + "/" + choixId, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
